import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  deleteNotificationMock,
  getNotificationDetailsMock,
  getNotificationMock,
  readNotificationMock,
  successMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { notificationPath } from '../../utils/paths';

export default {
  getNotification: (filters) => {
    if (shouldUseMock()) {
      return getNotificationMock(filters);
    }
    return apiCall(
      `${baseUrl}${notificationPath}notification/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  notificationRead: (params) => {
    if (shouldUseMock()) {
      return readNotificationMock();
    }
    return apiCall(
      `${baseUrl}${notificationPath}notifications/status`,
      'POST',
      params
    );
  },
  notificationDelete: (params) => {
    if (shouldUseMock()) {
      return deleteNotificationMock();
    }
    return apiCall(
      `${baseUrl}${notificationPath}notifications/delete`,
      'POST',
      params
    );
  },
  notificationDetailsGet: (id) => {
    if (shouldUseMock()) {
      return getNotificationDetailsMock();
    }
    return apiCall(
      `${baseUrl}${notificationPath}notification/${id}/details`,
      'GET'
    );
  },
  siteNotification: (payload) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${notificationPath}notification/set`,
      'POST',
      payload
    );
  },
};
